"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import * as Aria from 'react-aria-components';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import { FieldError } from '../FieldError/FieldError.mjs';
import clsx from 'clsx';
import styles from './TimeField.module.scss.mjs';

const TimeField = flowComponent("TimeField", (props) => {
  const { children, errorMessage, className, ref, ...rest } = props;
  const rootClassName = clsx(formFieldStyles.formField, className);
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired,
      isDisabled: rest.isDisabled
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    }
  };
  return /* @__PURE__ */ jsxs(
    Aria.TimeField,
    {
      ref,
      hourCycle: 24,
      className: rootClassName,
      ...rest,
      children: [
        /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }),
        /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError, children: errorMessage }),
        /* @__PURE__ */ jsx(Aria.DateInput, { className: styles.dateInput, children: (segment) => /* @__PURE__ */ jsx(Aria.DateSegment, { segment }) })
      ]
    }
  );
});

export { TimeField, TimeField as default };
//# sourceMappingURL=TimeField.mjs.map
